import ChattelSelect from 'components/ChattelSelect';
import { Button, FormInput, Icon, moneyFormat } from 'modules';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

export interface Chattel {
  druh: string | null;
  popis: string;
  cena: number;
}

interface ChattelsListProps {
  name: string;
  list: Chattel[];
  readOnly?: boolean;
  onChange: (account: Chattel[]) => void;
}

const ChattelsList = ({ name, list, readOnly, onChange }: ChattelsListProps) => {
  const [newRow] = useState(true);
  const [newRowData, setNewRowData] = useState<Chattel>({
    druh: null,
    popis: '',
    cena: 0,
  });

  const onChangeNewRowData = (e: React.ChangeEvent) => {
    const { name, value } = e.target as HTMLInputElement;
    setNewRowData({
      ...newRowData,
      [name]: value,
    });
  };

  const isValid = (): boolean => {
    return newRowData.druh !== '' && newRowData.cena > 0;
  };

  const onSaveNewRow = () => {
    if (isValid()) {
      const newList = [...list];
      newList.push(newRowData);
      onChange({
        target: {
          name,
          value: newList,
        },
      } as any);
      setNewRowData({
        druh: null,
        popis: '',
        cena: 0,
      });
    }
  };

  const onDeleteRow = (index: number): void => {
    const newList = list.filter((p, i: number) => i !== index);
    onChange({
      target: {
        name,
        value: newList,
      },
    } as any);
  };

  return (
    <>
      {list.map((a: Chattel, index: number) => {
        return (
          <Row key={index}>
            <Col sm={4}>
              <FormInput name="druh" value={a.druh} readOnly={true} />
            </Col>
            <Col sm={5}>
              <FormInput name="popis" value={a.popis} readOnly={true} />
            </Col>
            <Col sm={3} className="d-flex">
              <FormInput name="cena" className="text-right" value={moneyFormat(a.cena)} readOnly={true} />
              {readOnly !== true && (
                <Button
                  type="button"
                  variant="danger"
                  className="btn-input-size ml-1"
                  onClick={() => onDeleteRow(index)}
                >
                  <Icon type="times" />
                </Button>
              )}
            </Col>
          </Row>
        );
      })}

      {newRow === true && readOnly !== true && (
        <Row>
          <Col sm={4}>
            <ChattelSelect name="druh" value={newRowData.druh} onChange={onChangeNewRowData} />
          </Col>
          <Col sm={5}>
            <FormInput name="popis" placeholder="Popis" value={newRowData.popis} onChange={onChangeNewRowData} />
          </Col>
          <Col sm={3} className="d-flex">
            <FormInput
              type="number"
              name="cena"
              placeholder="Cena (EUR)"
              value={newRowData.cena}
              onChange={onChangeNewRowData}
            />
            <Button
              type="button"
              variant="primary"
              disabled={!isValid()}
              className="btn-input-size ml-1"
              onClick={onSaveNewRow}
            >
              <Icon type="check" />
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ChattelsList;
